itsoftApp.createModule("startLoad", ["pageLoad"], function () {
    const module = this;

    const LibraryLoader = function (func, library) {
        this.func = func;
        this.library = library;
        
        this.startLoad();
    };

    LibraryLoader.prototype.initQueue = function () {
        const LIBRARY_LOADER = this;

        if (!LIBRARY_LOADER.library.loaded) {
            return false;
        }

        if (!LIBRARY_LOADER.library.queue.length) {
            return;
        }

        DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] initQueue function fired, queue.length: " + LIBRARY_LOADER.library.queue.length);

        while (LIBRARY_LOADER.library.queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            LIBRARY_LOADER.library.queue.shift()();
        }
    };

    LibraryLoader.prototype.loadScriptStart = function (f) {
        const LIBRARY_LOADER = this;

        itsoftApp.loadScript(LIBRARY_LOADER.library.script, function () {
            DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] library loaded, ready to init queue");
            f();
        });
    }

    LibraryLoader.prototype.loadAndInit = function () {
        const LIBRARY_LOADER = this;

        const f = function () {
            if (!LIBRARY_LOADER.library.loaded && LIBRARY_LOADER.library.cb && typeof LIBRARY_LOADER.library.cb === "function") {
                LIBRARY_LOADER.library.cb();
            }
            
            LIBRARY_LOADER.library.loaded = true;
            LIBRARY_LOADER.initQueue();
        };

        if (LIBRARY_LOADER.library.hasOwnProperty("style")) {
            itsoftApp.loadStyle(LIBRARY_LOADER.library.style);
        }

        if (LIBRARY_LOADER.library.hasOwnProperty("dependency") && LIBRARY_LOADER.library.dependency) {
            new itsoftApp.modules.startLoad.callback(function () {
                LIBRARY_LOADER.loadScriptStart(f);
            }, itsoftApp.libraries[LIBRARY_LOADER.library.dependency]);
        } else {
            LIBRARY_LOADER.loadScriptStart(f);
        }
    };

    LibraryLoader.prototype.addEvent = function () {
        const LIBRARY_LOADER = this;

        if (typeof this.func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!this.library.loaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!this.library.started) {
                this.library.started = true;
                DEBUG && console.log("%c--[module" + this.library.name + "] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(function () {
                    LIBRARY_LOADER.loadAndInit();
                });
            }
            this.library.queue.push(this.func);
            DEBUG && console.log("[module " + this.library.name + "] function added, count of functions to init now: " + this.library.queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            this.func();
        }
    };

    LibraryLoader.prototype.startLoad = function () {
        this.addEvent(this.func);
    };


    // Доступ к функциям
    // текущего модуля
    module.callback = LibraryLoader;
});